import {NgModule} from '@angular/core';

import {GeolocationService} from './geolocation.service';

@NgModule({
  providers: [GeolocationService],
})
export class GeolocationModule {}
